export default {"src":"/_next/static/media/guarantee.3853a60c.svg","height":28,"width":22,"blurWidth":0,"blurHeight":0};